const Shift = {
    data() {
        return {
            cargando: false,
            nuevoTurno: {
                servicio_id: null,
                nombre: '',
                intervalo_inicio: '',
                intervalo_fin: '',
                dias_aplicables: []
            },
            ventanas: [],
            ventanasValidacion: [],
            servicios: [],
            diasSemana: [],
            turnosCatalogo: [],
            turnosSeleccionados: [],
            headersCatalogo: [
                { text: 'Servicio', value: 'servicio_id' },
                { text: 'Nombre del Turno', value: 'nombre' },
                { text: 'Días', value: 'dias_aplicables' },
                { text: 'Inicio', value: 'intervalo_inicio' },
                { text: 'Fin', value: 'intervalo_fin' },
                { text: 'Acciones', value: 'acciones', sortable: false }
            ],
            turnoEditando: null,
            modoEdicion: false,
            selectAllDiasAplicables: false,
            dialogEliminar: {
                visible: false,
                id: null,
                nombre: ''
            },
            intervalosHora: this.generarIntervalos(),
            ordenDiasSemana: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
            mostrarSelectorImportarTurnos: false,
            servicioOrigenSeleccionadoTurno: null,
            servicioDestinoSeleccionado: null,
            turnosCopiadosTemporal: [],
            turnoEditando: null,
            indiceEditando: -1,
            isSaving: false,

            //generacion automatica
            dialogoGeneracion: false,
            servicioGeneracionId: null,

            diasDisponiblesGeneracion: [],
            diasSeleccionadosGeneracion: [],
            mostrarPrevisualizacion: false,
            turnosPrevisualizacion: [],

            // NUEVAS VARIABLES
            duracionTurnoMinutos: 480,
            duracionOpciones: [
                { text: '4 Horas (240 min)', value: 240 },
                { text: '5 Horas (300 min)', value: 300 },
                { text: '6 Horas (360 min)', value: 360 },
                { text: '7 Horas (420 min)', value: 420 },
                { text: '8 Horas (480 min)', value: 480 },
                { text: '9 Horas (540 min)', value: 540 },
                { text: '10 Horas (600 min)', value: 600 },
                { text: '11 Horas (660 min)', value: 660 },
                { text: '12 Horas (720 min)', value: 720 },
            ],

            tipoGeneracion: 'escalonado',
            tiposGeneracion: [
                { text: 'Escalonado (Turno A termina donde empieza B)', value: 'escalonado' },
                { text: 'Empalmado (Turno B inicia antes de que A termine)', value: 'empalmado' },
            ],

            intervaloEntreTurnosMinutos: 60,
            intervaloOpciones: [
                { text: '15 minutos', value: 15 },
                { text: '30 minutos', value: 30 },
                { text: '60 minutos (1 hora)', value: 60 }
            ],
            previsualizacionHeaders: [
                { text: 'Bloque', value: 'nombre' },
                { text: 'Inicio', value: 'intervalo_inicio' },
                { text: 'Fin', value: 'intervalo_fin' },
                { text: 'Días', value: 'dias_aplicables' },
            ],
            horasTimeline: [],
            horaInicioTimeline: null,
            horaFinTimeline: null,
            coloresTimeline: ['#1976D2', '#4CAF50', '#FF9800', '#F44336', '#9C27B0'],
            alturaCarril: 35,
            dialogEliminar: { id: null, nombre: '', visible: false },
            dialogEliminarMasivo: { nombre: '', visible: false },
        };
    },
    mounted() {
        this.cargarCatalogo();
        this.cargarServicios();
    },
    computed: {
        ventanaActiva() {
            const dia = this.nuevoTurno.dias_aplicables?.[0];
            return this.ventanas.find(v => v.dia_semana === dia) || null;
        },
        nombreTurnoGenerado: {
            get() {
                if (this.nuevoTurno.nombre) {
                    return this.nuevoTurno.nombre;
                }

                const servicioSeleccionado = this.servicios.find(s => s.id === this.nuevoTurno.servicio_id);
                const nombreServicio = servicioSeleccionado ? servicioSeleccionado.nombre : 'Servicio';

                let diasTexto = '';
                if (this.nuevoTurno.dias_aplicables.length === this.diasSemana.length) {
                    diasTexto = 'Todos los días';
                } else if (this.nuevoTurno.dias_aplicables.length > 0) {
                    diasTexto = this.nuevoTurno.dias_aplicables.join(', ');
                } else {
                    diasTexto = 'Días sin definir';
                }

                const horaInicio = this.nuevoTurno.intervalo_inicio || 'HH:MM';
                const horaFin = this.nuevoTurno.intervalo_fin || 'HH:MM';

                return `${nombreServicio} - ${diasTexto} (${horaInicio} a ${horaFin})`;
            },
            set(value) {
                this.nuevoTurno.nombre = value;
            }
        },
        hayTurnosInvalidos() {
            return this.turnosCopiadosTemporal.some(turno => !turno.esValido);
        },
        selectAllDiasGeneracion: {
            get() {
                return this.diasSeleccionadosGeneracion.length === this.diasDisponiblesGeneracion.length && this.diasDisponiblesGeneracion.length > 0;
            },
            set(value) {
                if (value) {
                    this.diasSeleccionadosGeneracion = [...this.diasDisponiblesGeneracion];
                } else {
                    this.diasSeleccionadosGeneracion = [];
                }
            }
        }
    },
    watch: {
        selectAllDiasAplicables(newVal) {
            if (!this.nuevoTurno.servicio_id) {
                if (newVal === true) {
                    setTimeout(() => {
                        this.selectAllDiasAplicables = false;
                    }, 0);
                    this.$toast.error('Por favor, selecciona un servicio primero.');
                }
                return;
            }
            if (this.isManualChange && newVal === false) {
                this.isManualChange = false;
                return;
            }
            if (newVal) {
                this.nuevoTurno.dias_aplicables = [...this.diasSemana];
            } else {
                this.nuevoTurno.dias_aplicables = [];
            }
        },

        'nuevoTurno.dias_aplicables': {
            handler(newVal) {
                const isFullSelection = (newVal.length === this.diasSemana.length);
                if (this.selectAllDiasAplicables && !isFullSelection) {
                    this.isManualChange = true;
                }
                this.selectAllDiasAplicables = isFullSelection;
            },
            deep: true
        }
    },
    methods: {
        ordenarDias(dias) {
            if (!dias || dias.length === 0) return [];

            const ordenMap = this.ordenDiasSemana.reduce((acc, dia, index) => {
                acc[dia] = index;
                return acc;
            }, {});

            return dias.slice().sort((a, b) => {
                const indexA = ordenMap[a] !== undefined ? ordenMap[a] : 99;
                const indexB = ordenMap[b] !== undefined ? ordenMap[b] : 99;

                return indexA - indexB;
            });
        },
        async cargarServicios() {
            try {
                const usuarioId = this.$store.state.id;
                const res = await this.$axios.get(`list-services?usuario=${usuarioId}`);
                this.servicios = res.data;
            } catch (err) {
                console.error('Error al cargar servicios:', err);
                this.$toast.error('No se pudieron cargar los servicios');
            }

        },
        async cargarVentanaServicio() {
            const res = await this.$axios.get(`ventana-servicio/${this.nuevoTurno.servicio_id}`);
            this.ventanas = res.data;
            this.diasSemana = res.data.map(v => v.dia_semana);
        },
        async cargarVentanaServicioValidacion(id) {
            const res = await this.$axios.get(`ventana-servicio/${id}`);
            this.ventanasValidacion = res.data;
        },
        async guardarTurno() {
            this.nuevoTurno.nombre = this.nombreTurnoGenerado;
            if (!this.esTurnoValido(this.nuevoTurno)) {

                this.$toast.error('Completa todos los campos obligatorios del turno.');
                return;
            }
            const validacionInicio = this.validarInicio(this.nuevoTurno);
            if (validacionInicio !== true) {
                this.$toast.error(`Error de inicio: ${validacionInicio}`);
                return;
            }

            const validacionFin = this.validarFin(this.nuevoTurno);
            if (validacionFin !== true) {
                this.$toast.error(`Error de fin: ${validacionFin}`);
                return;
            }
            const res = await this.$axios.post('catalogo-turnos', this.nuevoTurno);
            if (res.data.status === 'ok') {
                this.$toast.success('Turno guardado correctamente');
                this.resetFormulario();
                this.cargarCatalogo();
            } else {
                this.$toast.error(res.data.message || 'Error al guardar el turno');
            }
        },
        validarInicio(turno) {
            if (!this.ventanaActiva) {
                return true;
            }
            console.log(this.ventanaActiva);
            const inicio = turno.intervalo_inicio?.slice(0, 5);
            const horasValidas = this.generarHorasValidas(
                this.ventanaActiva?.hora_apertura.slice(0, 5),
                this.ventanaActiva?.hora_cierre.slice(0, 5)
            );

            return horasValidas.includes(inicio)
                ? true
                : 'Hora fuera del rango permitido';
        },


        validarFin(turno) {
            const inicio = turno.intervalo_inicio;
            const fin = turno.intervalo_fin;
            const ventana = this.ventanaActiva;

            if (!inicio || !fin || !ventana) {
                return true;
            }

            const aperturaMins = this.tiempoAMinutos(ventana.hora_apertura);
            const cierreMins = this.tiempoAMinutos(ventana.hora_cierre);
            const inicioTurnoMins = this.tiempoAMinutos(inicio);
            let finTurnoMins = this.tiempoAMinutos(fin);

            const esHorarioNocturno = aperturaMins >= cierreMins;


            if (esHorarioNocturno) {
                if (finTurnoMins < inicioTurnoMins) {
                    finTurnoMins += 1440;
                }

                let cierreAjustado = cierreMins;
                if (cierreMins <= aperturaMins) {
                    cierreAjustado += 1440;
                }

                if (finTurnoMins > cierreAjustado) {
                    return `Debe ser ≤ ${ventana.hora_cierre}`;
                }

            } else {

                // 1. Fin no puede ser mayor que Cierre
                if (finTurnoMins > cierreMins) {
                    return `Debe ser ≤ ${ventana.hora_cierre}`;
                }
            }

            if (finTurnoMins <= inicioTurnoMins) {
                return 'La hora de fin debe ser posterior a la de inicio.';
            }

            return true;
        },
        tiempoAMinutos(hora) {
            if (!hora) return 0;
            const [h, m] = hora.split(':').map(Number);
            return (h * 60) + m;
        },
        generarHorasValidas(horaApertura, horaCierre) {
            const formato = '2000-01-01T';
            const pasoMinutos = 30;

            let inicio = new Date(`${formato}${horaApertura}:00`);
            let fin = new Date(`${formato}${horaCierre}:00`);

            if (fin <= inicio) {
                fin.setDate(fin.getDate() + 1);
            }

            const horas = [];
            while (inicio <= fin) {
                horas.push(inicio.toTimeString().slice(0, 5));
                inicio.setMinutes(inicio.getMinutes() + pasoMinutos);
            }

            return horas;
        },

        compararHoras(hora1, hora2) {
            return hora1.localeCompare(hora2) >= 0;
        },
        async actualizarTurno() {
            if (!this.esTurnoValido(this.nuevoTurno)) {
                this.$toast.error('Completa todos los campos obligatorios del turno de manera correcta.');
                return;
            }
            const res = await this.$axios.put(`catalogo-turnos/${this.nuevoTurno.id}`, this.nuevoTurno);
            if (res.data.status === 'ok') {
                this.$toast.success('Turno actualizado correctamente');
                this.resetFormulario();
                this.cargarCatalogo();
                this.modoEdicion = false;
            } else {
                this.$toast.error(res.data.message || 'Error al actualizar turno');
            }
        },
        resetFormulario() {
            this.nuevoTurno = {
                servicio_id: null,
                nombre: '',
                intervalo_inicio: '',
                intervalo_fin: '',
                dias_aplicables: []
            };
            this.modoEdicion = false;
            this.$refs.formTurno.resetValidation();
        },
        async cargarCatalogo() {
            this.cargando = true;
            try {
                const usuarioId = this.$store.state.id;
                const res = await this.$axios.get(`catalogo-turnos?usuario=${usuarioId}`);
                this.turnosCatalogo = res.data.map(t => ({
                    ...t,
                    dias_aplicables: Array.isArray(t.dias_aplicables) ? t.dias_aplicables : t.dias_aplicables.replace('{', '').replace('}', '').split(',') // si lo guardaste como TEXT[]
                }));
            } catch (error) {
                console.error(error);
                this.$toast.error('Error de conexión');
            } finally {
                this.cargando = false;
            }

        },
        obtenerNombreServicio(id) {
            const servicio = this.servicios.find(s => s.id === id);
            return servicio ? servicio.nombre : `ID ${id}`;
        },
        editarTurno(turno) {
            let turnoParaFormulario = { ...turno };

            if (turnoParaFormulario.intervalo_inicio) {
                turnoParaFormulario.intervalo_inicio = turnoParaFormulario.intervalo_inicio.slice(0, 5); // Ej: "10:00:00" -> "10:00"
            }
            if (turnoParaFormulario.intervalo_fin) {
                turnoParaFormulario.intervalo_fin = turnoParaFormulario.intervalo_fin.slice(0, 5); // Ej: "16:00:00" -> "16:00"
            }

            this.nuevoTurno = turnoParaFormulario;
            this.modoEdicion = true;
            this.cargarVentanaServicio();

            this.$nextTick(() => {
                if (this.$refs.formTurno && this.$refs.formTurno.$el) {

                    this.$refs.formTurno.$el.scrollIntoView({
                        behavior: 'smooth', // Hace el scroll de forma animada
                        block: 'start'      // Alinea la parte superior del elemento con la parte superior de la ventana
                    });

                }
            });
        },
        eliminarTurno(item) {
            this.dialogEliminar.id = item.id;
            this.dialogEliminar.nombre = item.nombre;
            this.dialogEliminar.visible = true;
        },
        async confirmarEliminacion() {
            try {
                const res = await this.$axios.delete(`catalogo-turnos/${this.dialogEliminar.id}`);
                if (res.data.status === 'ok') {
                    this.$toast.success('Turno eliminado correctamente');
                    await this.cargarCatalogo();
                } else {
                    this.$toast.error('Error al eliminar');
                }
            } catch (err) {
                console.error(err);
                this.$toast.error('Error de conexión al eliminar');
            } finally {
                this.dialogEliminar.visible = false;
            }
        },
        esTurnoValido(turno) {
            return (
                turno.servicio_id &&
                turno.nombre &&
                turno.intervalo_inicio &&
                turno.intervalo_fin &&
                //turno.intervalo_fin > turno.intervalo_inicio &&
                turno.dias_aplicables.length > 0
            );
        },
        generarIntervalos() {
            const intervalos = [];
            for (let h = 0; h < 24; h++) {
                for (let m = 0; m < 60; m += 30) {
                    const hora = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
                    intervalos.push(hora);
                }
            }
            return intervalos;
        },
        async prepararVistaPrevia() {
            if (!this.servicioOrigenSeleccionadoTurno || !this.servicioDestinoSeleccionado) {
                this.$toast.warning('Por favor, selecciona tanto el servicio origen como el destino.');
                return;
            }
            if (this.servicioOrigenSeleccionadoTurno.id === this.servicioDestinoSeleccionado.id) {
                this.$toast.warning('El servicio Origen y Destino deben ser diferentes. No tiene sentido importar turnos a sí mismo.');
                return;
            }

            const idServicioOrigen = this.servicioOrigenSeleccionadoTurno.id;
            const idServicioDestino = this.servicioDestinoSeleccionado.id;
            await this.cargarVentanaServicioValidacion(idServicioDestino);
            const diasPermitidosDestino = this.ventanasValidacion.map(v => v.dia_semana);

            const nombreServicioDestino = this.servicioDestinoSeleccionado.nombre;
            const nombreServicioOrigen = this.servicioOrigenSeleccionadoTurno.nombre;

            const turnosDelOrigen = this.turnosCatalogo.filter(
                turno => turno.servicio_id === idServicioOrigen
            );

            if (turnosDelOrigen.length === 0) {
                this.$toast.error(`El servicio "${this.servicioOrigenSeleccionadoTurno.nombre}" no tiene bloques de turno registrados.`);
                this.turnosCopiadosTemporal = [];
                return;
            }

            this.turnosCopiadosTemporal = turnosDelOrigen.map(turno => {
                let nuevoTurno = {
                    ...turno,
                    servicio_id: idServicioDestino,
                    id: null,
                    creado_en: null,
                    esValido: true,
                    razonInvalidez: null,
                };

                let nuevoNombre = nuevoTurno.nombre;
                if (nuevoNombre.includes(nombreServicioOrigen)) {
                    nuevoNombre = nuevoNombre.replace(nombreServicioOrigen, nombreServicioDestino);
                } else {
                    const parteFijaDelNombre = nuevoNombre.substring(nuevoNombre.indexOf('-'));
                    nuevoNombre = `${nombreServicioDestino} ${parteFijaDelNombre}`;
                }
                nuevoTurno.nombre = nuevoNombre;

                const validacion = this.validarTurnoImportado(nuevoTurno);

                if (!validacion.esValido) {
                    nuevoTurno.esValido = false;
                    nuevoTurno.razonInvalidez = validacion.razon;
                }

                return nuevoTurno;
            });
            const turnosInvalidos = this.turnosCopiadosTemporal.filter(t => !t.esValido);
            const totalInvalidos = turnosInvalidos.length;

            if (totalInvalidos > 0) {

                const resumenErrores = turnosInvalidos.reduce((acc, turno) => {
                    let tipoError;
                    if (turno.razonInvalidez.includes('No tiene ventana configurada')) {
                        tipoError = 'Día No Configurado';
                    } else if (turno.razonInvalidez.includes('fuera del rango')) {
                        tipoError = 'Inicio Fuera de Rango';
                    } else if (turno.razonInvalidez.includes('excede el cierre')) {
                        tipoError = 'Fin Excede Cierre';
                    } else {
                        tipoError = 'Error Desconocido';
                    }

                    acc[tipoError] = (acc[tipoError] || 0) + 1;
                    return acc;
                }, {});

                const listaErrores = Object.keys(resumenErrores).map(razon => {
                    return `${resumenErrores[razon]} por "${razon}"`;
                }).join(', ');


                const mensajeDetallado = `Se cargaron ${totalInvalidos} turnos inválidos. Problemas principales: ${listaErrores}. Revise la columna 'Estado' en la tabla.`;

                this.$toast.warning(mensajeDetallado, { timeout: 10000 });
            }
        },
        obtenerVentanaPorDia(diaSemana) {
            return this.ventanasValidacion.find(ventana => ventana.dia_semana === diaSemana);
        },
        validarTurnoImportado(turno) {
            const resultado = { esValido: true, razon: null };
            const inicioTurno = turno.intervalo_inicio?.slice(0, 5);
            const finTurno = turno.intervalo_fin?.slice(0, 5);

            const tiempoAMinutos = (timeStr) => {
                if (!timeStr) return 0;
                const [h, m] = timeStr.split(':').map(Number);
                return (h * 60) + m;
            };

            for (const dia of turno.dias_aplicables) {
                const ventana = this.obtenerVentanaPorDia(dia);

                if (!ventana) {
                    resultado.esValido = false;
                    resultado.razon = `Día ${dia}: No tiene ventana configurada en el destino.`;
                    return resultado;
                }

                const aperturaVentana = ventana.hora_apertura.slice(0, 5);
                const cierreVentana = ventana.hora_cierre.slice(0, 5);

                const esVentana24Horas = (aperturaVentana === cierreVentana); // ⭐️ Nueva Definición

                // --- INICIO: VALIDACIÓN DE INICIO DE TURNO EN RANGO ---
                if (!esVentana24Horas) {
                    const horasValidas = this.generarHorasValidas(aperturaVentana, cierreVentana);

                    if (!horasValidas.includes(inicioTurno)) {
                        resultado.esValido = false;
                        resultado.razon = `Día ${dia}: Inicio (${inicioTurno}) fuera del rango (${aperturaVentana} - ${cierreVentana}).`;
                        return resultado;
                    }
                }


                const aperturaMin = tiempoAMinutos(aperturaVentana);
                let cierreMin = tiempoAMinutos(cierreVentana);
                let inicioTurnoMin = tiempoAMinutos(inicioTurno);
                let finTurnoMin = tiempoAMinutos(finTurno);

                const cruzaMedianoche = esVentana24Horas || (cierreVentana <= aperturaVentana);

                if (cruzaMedianoche) {
                    if (esVentana24Horas) {
                        cierreMin = 2880;
                    } else {
                        cierreMin += 1440;
                    }

                    if (esVentana24Horas && finTurnoMin === inicioTurnoMin) {
                        finTurnoMin += 1440;
                    }
                    else if (finTurnoMin < inicioTurnoMin) {
                        finTurnoMin += 1440;
                    }

                    if (inicioTurnoMin < aperturaMin) {
                        inicioTurnoMin += 1440;
                    }
                }

                if (finTurnoMin > cierreMin) {
                    resultado.esValido = false;
                    resultado.razon = `Día ${dia}: Fin (${finTurno}) excede el cierre (${cierreVentana}).`;
                    return resultado;
                }

                if (finTurnoMin <= inicioTurnoMin) {
                    resultado.esValido = false;
                    resultado.razon = `Día ${dia}: El fin (${finTurno}) debe ser posterior al inicio (${inicioTurno}).`;
                    return resultado;
                }

            }

            return resultado;
        },

        editarTurnoTemporal(item, index) {
            let turno = { ...item };
            if (turno.intervalo_inicio) {
                turno.intervalo_inicio = turno.intervalo_inicio.slice(0, 5);
            }
            if (turno.intervalo_fin) {
                turno.intervalo_fin = turno.intervalo_fin.slice(0, 5);
            }
            this.turnoEditando = turno;
            this.indiceEditando = index;
        },
        eliminarTurnoTemporal(index) {
            const turno = this.turnosCopiadosTemporal[index];

            this.turnosCopiadosTemporal.splice(index, 1);

            this.$toast.success(`Turno "${turno.nombre}" eliminado de la previsualización.`);

            if (this.indiceEditando === index) {
                this.turnoEditando = null;
                this.indiceEditando = -1;
            }
        },

        async guardarEdicionTemporal() {
            if (this.indiceEditando === -1 || !this.turnoEditando) {
                this.$toast.error('Error: No hay un turno en edición.');
                return;
            }

            const validacion = this.validarTurnoImportado(this.turnoEditando);

            this.turnoEditando.esValido = validacion.esValido;
            this.turnoEditando.razonInvalidez = validacion.razon;

            this.$set(this.turnosCopiadosTemporal, this.indiceEditando, this.turnoEditando);

            if (validacion.esValido) {
                this.$toast.success('Turno editado y validado correctamente.');
            } else {
                this.$toast.warning(`Turno editado, pero aún inválido: ${validacion.razon}`);
            }

            this.turnoEditando = null;
            this.indiceEditando = -1;
        },
        async guardarTurnosImportados() {
            this.isSaving = true;
            if (this.turnosCopiadosTemporal.length === 0 || !this.servicioDestinoSeleccionado) {
                this.isSaving = false;
                this.$toast.error('No hay turnos para importar o falta seleccionar el servicio destino.');
                return;
            }

            let guardadosExitosos = 0;
            let turnosNoGuardados = [];
            const turnosAGuardar = [...this.turnosCopiadosTemporal];

            for (const turno of turnosAGuardar) {
                try {
                    const res = await this.$axios.post('catalogo-turnos', turno);

                    if (res.data.status === 'ok') {
                        guardadosExitosos++;
                    } else {
                        turnosNoGuardados.push(turno.nombre);
                        console.error(`Error de API al guardar ${turno.nombre}:`, res.data.message);
                    }

                } catch (error) {
                    console.error(`Error al guardar turno ${turno.nombre}:`, error);
                    turnosNoGuardados.push(turno.nombre);
                }
            }
            let mensaje = `Proceso finalizado. Se guardaron ${guardadosExitosos} bloques de turno.`;
            if (turnosNoGuardados.length > 0) {
                mensaje += ` Hubo errores (${turnosNoGuardados.length}) al guardar: ${turnosNoGuardados.join(', ')}.`;
            }
            mensaje.includes('Hubo errores') ? this.$toast.error(mensaje) : this.$toast.success(mensaje);

            // Limpiar estado y cerrar modal
            this.mostrarSelectorImportarTurnos = false;
            this.turnosCopiadosTemporal = [];
            this.servicioOrigenSeleccionadoTurno = null;
            this.servicioDestinoSeleccionado = null;
            this.turnoEditando = null;

            this.cargarCatalogo();

            this.isSaving = false;
        },


        mostrarDialogoGeneracion() {
            this.servicioGeneracionId = null;
            this.diasSeleccionadosGeneracion = [];
            this.diasDisponiblesGeneracion = [];
            this.mostrarPrevisualizacion = false;
            this.dialogoGeneracion = true;
        },
        async cargarDiasGeneracion() {
            if (!this.servicioGeneracionId) {
                this.diasDisponiblesGeneracion = [];
                this.diasSeleccionadosGeneracion = [];
                return;
            }

            const ventanaOperativaCompleta = await this.obtenerVentanaOperativa(this.servicioGeneracionId);

            const diasUnicos = ventanaOperativaCompleta.map(item => item.dia_semana);

            this.diasDisponiblesGeneracion = diasUnicos;
            this.diasSeleccionadosGeneracion = [];

            if (diasUnicos.length === 1) {
                this.diasSeleccionadosGeneracion = [diasUnicos[0]];
            }
        },

        obtenerTiempo(hora) {
            const [h, m] = hora.split(':');
            const date = new Date();
            date.setHours(parseInt(h), parseInt(m), 0, 0);
            return date;
        },

        async generarTurnosAutomaticos() {
            if (!this.servicioGeneracionId || this.diasSeleccionadosGeneracion.length === 0) return;


            const ventanaOperativaCompleta = await this.obtenerVentanaOperativa(this.servicioGeneracionId);

            const ventanaFiltrada = ventanaOperativaCompleta.filter(item =>
                this.diasSeleccionadosGeneracion.includes(item.dia_semana)
            );

            if (ventanaFiltrada.length === 0) {
                alert("Error: Ninguno de los días seleccionados tiene una Ventana Operativa definida en el sistema.");
                return;
            }

            let horaInicioComun = ventanaFiltrada[0].hora_apertura;
            let horaFinComun = ventanaFiltrada[0].hora_cierre;

            for (const dia of ventanaFiltrada) {
                if (dia.hora_apertura < horaInicioComun) {
                    horaInicioComun = dia.hora_apertura;
                }
                if (dia.hora_cierre > horaFinComun) {
                    horaFinComun = dia.hora_cierre;
                }
            }

            const esServicio24Horas = horaInicioComun.substring(0, 5) === horaFinComun.substring(0, 5);

            this.horaInicioTimeline = horaInicioComun.substring(0, 5);
            this.horaFinTimeline = esServicio24Horas ? "24:00" : horaFinComun.substring(0, 5);
            //this.horaFinTimeline = horaFinComun.substring(0, 5);       // Ej: "16:00"
            this.calcularEjeHorario(this.horaInicioTimeline, this.horaFinTimeline);


            const turnosAGuardar = [];
            const duracion = this.duracionTurnoMinutos;
            const intervaloInicio = this.tipoGeneracion === 'escalonado' ? duracion : this.intervaloEntreTurnosMinutos;
            let contadorTurno = 1;

            let currentTime = this.obtenerTiempo(horaInicioComun);
            const finalTime = this.obtenerTiempo(horaFinComun);

            const esHorarioNocturno = finalTime.getTime() < currentTime.getTime();

            if (esServicio24Horas || esHorarioNocturno) {
                finalTime.setDate(finalTime.getDate() + 1);

                if (esHorarioNocturno) {
                    this.horaFinTimeline = horaFinComun.substring(0, 5) + ' (siguiente día)';
                    this.calcularEjeHorario(this.horaInicioTimeline, this.horaFinTimeline);
                }
            }

            while (currentTime.getTime() < finalTime.getTime()) {

                let nextTime = new Date(currentTime.getTime() + duracion * 60000);

                if (nextTime.getTime() > finalTime.getTime()) {
                    break;
                }

                turnosAGuardar.push({
                    servicio_id: this.servicioGeneracionId,
                    nombre: `Bloque ${contadorTurno} (${this.formatoHora(currentTime)} - ${this.formatoHora(nextTime)})`,
                    intervalo_inicio: this.formatoHora(currentTime),
                    intervalo_fin: this.formatoHora(nextTime),
                    dias_aplicables: this.diasSeleccionadosGeneracion,
                });

                currentTime = new Date(currentTime.getTime() + intervaloInicio * 60000);
                contadorTurno++;
            }

            this.turnosPrevisualizacion = turnosAGuardar;
            this.mostrarPrevisualizacion = true;
        },
        async guardarTurnosPrevisualizados() {
            this.isSaving = true;
            if (this.turnosPrevisualizacion.length === 0) {
                this.isSaving = false;
                this.$toast.error('No hay turnos para guardar.');
                return;
            }

            const totalTurnos = this.turnosPrevisualizacion.length;
            let turnosGuardados = 0;
            let turnosFallidos = 0;

            for (const turno of this.turnosPrevisualizacion) {
                try {
                    const res = await this.$axios.post('catalogo-turnos', turno);

                    if (res.data.status === 'ok') {
                        turnosGuardados++;
                    } else {
                        turnosFallidos++;
                        console.error(`Error de API al guardar `, res.data.message, turno);
                    }

                } catch (error) {
                    turnosFallidos++;
                    console.error("Error de red o servidor al guardar un turno:", error, turno);
                }
            }

            if (turnosFallidos === 0) {
                this.$toast.success(`Se guardaron exitosamente ${turnosGuardados} de ${totalTurnos} turnos.`);
            } else if (turnosGuardados > 0) {
                this.$toast.warning(`Éxito parcial: Se guardaron ${turnosGuardados} turnos, pero ${turnosFallidos} fallaron.`);
            } else {
                this.$toast.error(`Error grave: Fallaron los ${turnosFallidos} turnos. Revise la consola.`);
            }
            this.turnosPrevisualizacion = [];
            this.mostrarPrevisualizacion = false;
            this.cargarCatalogo();

            this.isSaving = false;
            this.dialogoGeneracion = false;
        },

        formatoHora(date) {
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${hours}:${minutes}`;
        },
        async obtenerVentanaOperativa(servicioId) {
            const res = await this.$axios.get(`ventana-servicio/${servicioId}`);
            return res.data;
        },

        calcularEjeHorario(inicioStr, finStr) {
            this.horasTimeline = [];
            let start = this.obtenerTiempo(inicioStr);
            const end = this.obtenerTiempo(finStr);

            while (start <= end) {
                this.horasTimeline.push(this.formatoHora(start));
                start = new Date(start.getTime() + 60 * 60000);
            }
        },

        getTurnoEstilo(turno, index) {
            if (!this.horaInicioTimeline || !this.horaFinTimeline) return {};

            const totalMinutosVentana = this.calcularMinutosDesdeMedianoche(this.horaFinTimeline) - this.calcularMinutosDesdeMedianoche(this.horaInicioTimeline);
            const inicioTurnoMinutos = this.calcularMinutosDesdeMedianoche(turno.intervalo_inicio);
            const finTurnoMinutos = this.calcularMinutosDesdeMedianoche(turno.intervalo_fin);
            const inicioVentanaMinutos = this.calcularMinutosDesdeMedianoche(this.horaInicioTimeline);

            const duracionTurnoMinutos = finTurnoMinutos - inicioTurnoMinutos;
            const desplazamientoMinutos = inicioTurnoMinutos - inicioVentanaMinutos;

            const width = (duracionTurnoMinutos / totalMinutosVentana) * 100;
            const left = (desplazamientoMinutos / totalMinutosVentana) * 100;

            const colorIndex = index % this.coloresTimeline.length;
            const color = this.coloresTimeline[colorIndex];

            let top;
            let zIndex;

            if (this.tipoGeneracion === 'empalmado') {
                top = `${index * this.alturaCarril + 10}px`;
                zIndex = 10 + index;
            } else {
                top = '50%';
                zIndex = 1;
            }

            return {
                width: `${width}%`,
                left: `${left}%`,
                backgroundColor: color,
                top: top,
                zIndex: zIndex,
            };
        },

        calcularMinutosDesdeMedianoche(horaStr) {
            const [h, m] = horaStr.split(':').map(Number);
            return h * 60 + m;
        },
        confirmarEliminacionMasiva() {
            if (this.turnosSeleccionados.length === 0) return;

            this.dialogEliminarMasivo = {
                visible: true,
                nombre: `${this.turnosSeleccionados.length} bloques`,
            };
        },

        async ejecutarEliminacionMasiva() {
            this.isSaving = true;
            this.dialogEliminarMasivo.visible = false;
            let eliminadosConExito = 0;

            for (const turno of this.turnosSeleccionados) {
                try {
                    const res = await this.$axios.delete(`catalogo-turnos/${turno.id}`);
                    if (res.data.status === 'ok') {
                        eliminadosConExito++;
                    } else {
                        console.error(`Fallo al eliminar el turno ${turno.id}:`, res.data.message);
                    }
                } catch (err) {
                    console.error(`Error de conexión al eliminar el turno ${turno.id}:`, err);
                }
            }

            if (eliminadosConExito === this.turnosSeleccionados.length) {
                this.$toast.success(`Se eliminaron ${eliminadosConExito} turnos correctamente.`);
            } else if (eliminadosConExito > 0) {
                this.$toast.warning(`Éxito parcial: Se eliminaron ${eliminadosConExito} turnos. ${this.turnosSeleccionados.length - eliminadosConExito} fallaron.`);
            } else {
                this.$toast.error('Ninguno de los turnos seleccionados pudo ser eliminado. Revise la consola.');
            }

            this.turnosSeleccionados = [];
            await this.cargarCatalogo();
            this.isSaving = false;
        },

    }
}
export default Shift